<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Tài khoản</h2>
        <div>
          <el-button @click="goAttributeIndex" size="small" type="info" class="btn-create">Bộ lọc giảng viên</el-button>
          <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.user_type" filterable clearable placeholder="Loại tài khoản" class="input-select">
            <el-option
              v-for="item in lists.listUserType"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.domain_id" filterable clearable placeholder="Tên miền" class="input-select">
            <el-option
              v-for="item in lists.listDomain"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
<!--         <el-col :span="8">
          <el-date-picker
            style="height: 32px;"
            v-model="filter.date"
            @change="changeDateStatistic"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="To"
            start-placeholder="Ngày bắt đầu"
            end-placeholder="Ngày kết thúc">
          </el-date-picker>
        </el-col> -->
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="4">
        </el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới tài khoản <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> tài khoản
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="avatar"
            align="center"
            width="100"
            label="Ảnh đại diện">
            <template slot-scope="scope">
              <img v-if="scope.row.avatar_path" :src="scope.row.avatar_path" class="avatar-index">
              <img v-else src="../../static/images/avatars/default-avatar.png" class="avatar-index">
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            width="300"
            label="Họ và tên">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.name }}</p>
              <p>{{ scope.row.email }}</p>
              <p>{{ scope.row.phone }}</p>
              <p>Ngày sinh: {{ scope.row.birthday }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_type"
            label="Loại tài khoản">
            <template slot-scope="scope">
              <span v-if="scope.row.user_type == 1" style="color: #c0392b">{{ scope.row.user_type_txt }}</span>
              <span v-else style="color: green">{{ scope.row.user_type_txt }}</span>
              <p v-if="scope.row.user_code">Mã tài khoản: <span style="color: green">{{ scope.row.user_code }}</span></p>
              <p v-if="scope.row.user_introduce">Mã giới thiệu: {{ scope.row.user_introduce }}</p>
              <p v-if="scope.row.level_id">Phân hệ muốn học: {{ scope.row.level_name }}</p>
              <p>{{ scope.row.created_at }}</p>
              <p v-if="scope.row.user_type == 11">{{ scope.row.total_help_care }}/{{ scope.row.total_help_care_queue }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Địa chỉ">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.city_code">TP: {{ scope.row.city_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <div v-if="scope.row.expo_token">
                  <el-tooltip effect="dark" content="Đẩy thông báo" placement="top">
                    <span @click="pushNoti(scope.row)">
                      <i style="color: #12CE66" class="fas fa-bell"></i>
                    </span>
                  </el-tooltip>
                </div>
                <el-tooltip effect="dark" content="Mở khóa" placement="top">
                  <span v-if="scope.row.count_login_false > 5" @click="confirmOpenModel(scope.row)">
                    <i style="color: red" class="fas fa-times"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Reset Password" placement="top">
                  <span @click="confirmResetPassModel(scope.row)">
                    <i style="color: red" class="fas fa-power-off"></i>
                  </span>
                </el-tooltip>
<!--                 <el-tooltip effect="dark" content="Nạp tiền" placement="top">
                  <span @click="addPayment(scope.row)">
                    <i class="fas fa-dollar-sign"></i>
                  </span>
                </el-tooltip> -->
                <!-- Chỉ đối tượng là học viên mới có chức năng này -->
                <div v-if="scope.row.user_type == 3">
                  <el-tooltip effect="dark" content="Check-list Hồ Sơ" placement="top">
                    <span @click.prevent="getRequiredDoct(scope.row.id)">
                      <i class="fas fa-list-ol"></i>
                    </span>
                  </el-tooltip>
                </div>
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa GV" placement="top" v-if="scope.row.user_type == 2">
                  <span @click="updateModelTeacher(scope.row)">
                    <i class="fas fa-pencil-alt"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
<!--               <div class="module-action">
                <el-tooltip effect="dark" content="Sửa bộ lọc GV" placement="top" v-if="scope.row.user_type == 2">
                  <span @click="updateModelTeacherFilter(scope.row)">
                    <i class="fas fa-pen-square"></i>
                  </span>
                </el-tooltip>
              </div> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Nạp tiền cho ' + modelData.name + ' - ' + modelData.email"
      :visible.sync="dialogVisible"
      width="35%">
      <div>
        <el-input type="age" v-model.number="modelData.money" class="input-seach" auto-complete="off">
          <template slot="append">{{ modelData.money | vnd }}</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="charegePaymentForUser"  size="small">OK</el-button>
        </span>
    </el-dialog>

    <!-- dialog check-list danh mục hồ sơ -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Danh mục các hồ sơ cần bổ sung của học viên: ' + modelUser.name + ' -- Mã: ' + modelUser.user_code"
      :visible.sync="dialogRequiredDoct"
      top="50px"
      width="55%">
      <div>
        <div class="course-terms">
          <div style="margin-bottom: 5px" :key="item.doct_id" class="d-flex justify-content-between" v-for="(item) in modelUser.doc_info_show">
            <span style="font-size: 16px !important;">{{ item.doct_name }}</span>
            <div class="d-flex">
              <span class="space"></span>
              <el-checkbox v-model="item.doct_approve">Đã nộp</el-checkbox>
              <span class="space"></span>
              <el-date-picker
                  style="width: 250px;"
                  v-model="item.doct_submission_at"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="Ngày nộp">
              </el-date-picker>
              <span class="space"></span>
              <el-input v-model="item.doct_comment" :rows="2" type="textarea" class="input-seach"></el-input>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogRequiredDoct = false" size="small">Hủy</el-button>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="primary" @click="updateRequiredDoct"  size="small">Cập nhật</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Users',
  metaInfo () {
    return {
      title: 'Tài khoản'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      canSubmit: true,
      filter: {
        q: '',
        status: '',
        user_type: '',
        domain_id: '',
        daterange: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: '',
        date: ''
      },
      dialogVisible: false,
      dialogRequiredDoct: false,
      modelData: {
        name: '',
        email: '',
        user_id: 0,
        money: 5000000
      },
      modelUser: {},
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Họ và tên',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listUserType: [
          {key: 2, value: 'Giảng viên'},
          {key: 3, value: 'Học viên'},
          {key: 5, value: 'Admin trường'},
          {key: 11, value: 'Editor'}
        ],
        listDomain: []
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    if (this.accountInfo.user_type === 11) {
      this.$router.push({name: 'users-for-editor-index'})
    }

    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchDomain()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'users-index', text: 'Tài khoản' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'users-create'})
    },
    goAttributeIndex () {
      this.$router.push({name: 'attribute-keys-index'})
    },
    pushNoti (model) {
      this.$router.push({name: 'users-push', params: {id: model.id}})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('users', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch domain
    fetchDomain () {
      let filter = {
        'status': 1,
        'limit': -1
      }
      axios.get('domains', {params: filter}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listDomain = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      // let routeData = this.$router.resolve({name: 'users-show', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'users-show', params: {id: model.id}})
    },
    updateModel (model) {
      // let routeData = this.$router.resolve({name: 'users-update', params: {id: model.id}})
      // window.open(routeData.href, '_blank')
      this.$router.push({name: 'users-update', params: {id: model.id}})
    },
    updateModelTeacher (model) {
      this.$router.push({name: 'users-update-teacher', params: {id: model.id}})
    },
    updateModelTeacherFilter (model) {
      this.$router.push({name: 'users-update-filter-teacher', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('users/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmResetPassModel
    confirmResetPassModel (model) {
      this.$confirm('Xác nhận Reset mật khẩu về mặc định cho tài khoản: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.resetPassModel(model)
      }).catch(() => {

      })
    },
    resetPassModel (model) {
      axios.post('users/reset-password/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Reset mật khẩu cho tài khoản thành công',
              type: 'success'
            })
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    // confirmOpenModel
    confirmOpenModel (model) {
      this.$confirm('Xác nhận mở khóa cho tài khoản: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.resetOpenModel(model)
      }).catch(() => {

      })
    },
    resetOpenModel (model) {
      axios.post('users/open-account/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Mở khóa cho tài khoản thành công',
              type: 'success'
            })
            model.count_login_false = 0
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa tài khoản: ' + model.email + ' Dữ liệu sẽ bị xóa hoàn toàn ?', 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('users/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    // Thay đổi ngày tìm kiếm
    changeDateStatistic () {
      this.fetchDatabaseModel()
    },
    addPayment (model) {
      this.dialogVisible = true
      this.modelData.name = model.name
      this.modelData.email = model.email
      this.modelData.user_id = model.id
    },
    charegePaymentForUser () {
      this.canSubmit = false
      axios.post('payments', this.modelData).then(response => {
        this.canSubmit = true
        this.dialogVisible = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Nạp thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lấy thông tin tình trạng các danh mục hồ sơ của học viên
    getRequiredDoct (id) {
      this.dialogRequiredDoct = true
      axios.get('users/show-doct-status/' + id).then(response => {
        switch (response.code) {
          case 200:
            this.modelUser = response.data
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Cập nhật thông tin tình trạng các danh mục hồ sơ của học viên
    updateRequiredDoct () {
      this.canSubmit = false
      axios.post('users/update-doct-status/' + this.modelUser.id, this.modelUser).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.getRequiredDoct(this.modelUser.id)
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.user_type': function () {
      this.fetchDatabaseModel()
    },
    'filter.domain_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.avatar-index {
  width: 60px;
  border-radius: 50%;
}
.model-content {
  padding-top: 15px;
  height: 100vh - 120px;
  overflow-y: scroll;
}
.huhu {
  margin-top: 10px;
  margin-bottom: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line .name {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  min-width: 250px;
}
.line .space {
  width: 30px;
  display: inline-block;
  text-align: center;
}
.line-1 {
  background-color: #eaeeaa;
  background-color: #f1f1f1;
  padding: 5px 5px;
}
.line-2 {
  background-color: #ddd;
  padding: 5px 5px;
}
.line-2 .name {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  min-width: 350px;
}
.line-2 .code-2 {
  min-width: 100px;
  font-weight: bold;
}
.priority-2 {
  min-width: 80px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
.space {
  display: inline-block;
  min-width: 25px;
}

.main-term {
  background-color: #f2f2f2;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 10px;
}
.main-term .text {
  font-weight: bold;
  font-size: 18px;
  margin-right: 40px;
}

.main-term .el-input {
  width: 250px;
  margin-left: 10px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/users/Index.vue